export const config = {
  apiUrl: 'https://api2.mosayyebi.com/api/v1/',
  appApiUrl: 'https://api2.mosayyebi.com/app/v1/',
  uploadsUrl: 'https://api2.mosayyebi.com/',
  // apiUrl: 'https://localhost:44366/api/v1/',
  // appApiUrl: 'https://localhost:44366/app/v1/',
  // uploadsUrl: 'https://localhost:44366/',
};
